import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { DualScore } from "./DualScore";

const mid = (p) => Math.round(((+p.limit_low + +p.limit_high) / 2) * 100) / 100;
const orderText = (p) =>
  `ACHAT LIMIT ${p.ticker} · ${Math.floor(p.shares)} actions · limite $${mid(p)} (milieu de zone $${p.limit_low}–$${p.limit_high}) · invalidation $${p.invalidation}`;

export const PickCard = ({ p, score, loading }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    const txt = orderText(p);
    try {
      await navigator.clipboard.writeText(txt);
      setCopied(true);
    } catch (e) {
      window.prompt("Copie l'ordre :", txt);
    }
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <div className="bg-slate-900/70 border border-slate-700 hover:border-emerald-500/50 transition-colors rounded-lg p-3 space-y-2" data-testid={`pick-${p.ticker}`}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-base font-bold text-slate-50">{p.ticker}</span>
        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${p.verdict === "GO" ? "text-emerald-300 border-emerald-500/40 bg-emerald-500/10" : "text-amber-300 border-amber-500/40 bg-amber-500/10"}`}>
          {p.verdict || "—"}
        </span>
      </div>
      <DualScore s={score} loading={loading} ticker={p.ticker} />
      <div className="grid grid-cols-2 gap-x-3 gap-y-0.5 text-xs">
        <span className="text-slate-500">Montant</span><span className="text-right font-mono text-slate-200">€{Math.round(p.amount_eur).toLocaleString("fr-FR")}</span>
        <span className="text-slate-500">Quantité</span><span className="text-right font-mono text-slate-200">{Math.floor(p.shares)}</span>
        <span className="text-slate-500">Zone LIMIT</span><span className="text-right font-mono text-cyan-300">${p.limit_low} – ${p.limit_high}</span>
        <span className="text-slate-500">Prix limite</span><span className="text-right font-mono text-cyan-200 font-bold">${mid(p)}</span>
        <span className="text-slate-500">Invalidation</span><span className="text-right font-mono text-red-300">${p.invalidation}</span>
      </div>
      <button onClick={copy}
        className="w-full inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-full py-1.5 bg-slate-800 hover:bg-emerald-600 border border-slate-600 hover:border-emerald-500 text-slate-100 transition-colors"
        data-testid={`pick-copy-${p.ticker}`}>
        {copied ? <><Check className="w-3.5 h-3.5" /> Ordre copié</> : <><Copy className="w-3.5 h-3.5" /> Copier l'ordre</>}
      </button>
    </div>
  );
};
